import React from "react";
import logo from "../assests/logo.png";

const Navbar = () => {

  return (
    <>
      <header className="header-top py-2 bg-white sticky-top" id="hea">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6  mb-3 mb-md-0 text-center text-md-left">
              <ul className="list-inline mb-0 topcontact">
                <li className="list-inline-item mr-3">
                  <span className="icon icon-Phone2 text-primary mr-1">
                    <i className="fa fa-phone  text-primary mr-1 pt-1"></i>
                  </span>

                  <a
                    onClick={() => {
                      window.gtag_report_conversion('tel:7583837701');
                      window.gtag('event', 'bottom_button_click_call')
                    }}
                    href="tel:7583837701"
                  >
                    758383 7701
                  </a>
                </li>
                <li className="list-inline-item">
                  <span className="icon icon-Mail "></span>
                  <i
                    className="fa fa-envelope text-primary mr-1 pt-1"
                    aria-hidden="true"
                  ></i>
                  <a
                    onClick={() => {
                      window.gtag_report_conversion('mailto:info@premisin.com');
                    }}
                    href="mailto:info@premisin.com"
                  >
                    info@premisin.com
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 mb-3 mb-md-0 social-m">
              <ul className="list-inline social social-rounded social-default social-sm mb-0 text-center text-md-right">
                <li className="list-inline-item">
                  <a
                    onclick="called_phone_gads_track();"
                    href="https://www.facebook.com/premisin/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    onclick="called_phone_gads_track();"
                    href="https://twitter.com/premisin/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    onclick="called_phone_gads_track();"
                    href="https://www.instagram.com/premisinraipur/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    onclick="called_phone_gads_track();"
                    href="https://www.linkedin.com/in/premisin/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <div className="sticky-top  ">
        <div className="header header-shadow header-shrink  bg-gray-v2 py-0 ">
          <div className="container">
            <nav className="navbar navbar-expand-lg">
              <a className="navbar-brand" href="/#">
                <img src={logo} alt="Premisin" style={{ maxWidth: "150px" }} />
              </a>
              <button
                className="navbar-toggler p-0"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarSupportedContent"
                aria-expanded="true"
                aria-label="Toggle navigation"
              >
                <span className="hamburger hamburger--spin js-hamburger">
                  <span className="hamburger-box">
                    <span className="hamburger-inner"></span>
                  </span>
                </span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item active">
                    <a className="nav-link" href="/#">
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#office-space">
                      Office Space
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#why-choose">
                      Why Premisin?
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#clients">
                      Our Clients
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#about">
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#locations">
                      Locations
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#contact">
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
